<template>
  <tea-main @back="goBack">
    <template slot="nav">
      <div class="recordNav">
        <p>申诉信息详情<span v-if="['system', 'super', 'sysFive', 'supFive','viewer','viewFive'].includes(member_type)">&nbsp;&nbsp;&nbsp;（#{{peopleAppeal.appeal_id}}）</span> </p>
        <div style="display: flex" v-if="!['viewer','viewFive'].includes(member_type)">
          <p class="audit" @click="verify()" v-if="peopleAppeal.status==='audit'">审核申诉信息</p>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="recordMain">
        <yioks-loading v-show="loading"></yioks-loading>
          <div v-if="!loading" class="Info">
              <vue-scroll :ops="ops" ref="vs">
                <div class="mainInfo" v-if="auditData.length>0 || peopleAppeal.name">
                    <template v-if="auditData.length>0">
                        <div class="title" style="display: flex;justify-content: space-between">
                            <div style="display: flex">
                                <v-icon class="logo" name="regular/clock" scale="1.6"></v-icon>
                                <p class="titleInfo">申诉信息审核过程</p>
                            </div>
                            <div style="display: flex;justify-content: space-between ;">
                              <div class="zuxie-btn" @click="lookOver">查看处罚结果</div>
                            </div>
                        </div>
                        <div class="timeline">
                            <div
                                    class="timeline-item"
                                    v-for="(audit, i) in auditData"
                                    :key="audit.audit_id"
                            >
                                <div
                                        class="item_tail"
                                        v-show="i !== auditData.length - 1"
                                ></div>
                                <div class="item_node" v-if="audit.audit_type === 'audit_appeal'">
                                    {{ audit.status |auditStatus }}
                                </div>
                                <div class="item_node" v-else>
                                    提交
                                </div>
                                <div class="item_wrap">
                                    <div class="timestamp">
                                        <span >{{ audit.create_time | time }}</span>
                                        <!--                                               <span class="audit_people" v-if="audit.type ==='audit_score'">-->
                                        <!--                            审核人：{{audit.unit_name | userRole}}（{{audit.name}}）-->
                                        <!--                          </span>-->
<!--                                        <span class="audit_people" v-if="audit.audit_type==='submit_qua'">-->
<!--                              提交人：{{ audit.name }}-->
<!--                            </span>-->
<!--                                        <span class="audit_people" v-else>-->
<!--                                  审核人：{{ audit.name }}-->
<!--                              </span>-->
                                    </div>
                                    <div class="item_cont">
                                        <p>
                              <span v-if="audit.audit_type==='submit_appeal'">
                                  申诉信息提交成功，正在审查。
                              </span>
                                <span v-else-if="audit.status==='pass'">
                                审核通过
                                </span>
                                <span v-else>
                                    审核
                                </span>
                                            <span
                                                    v-if="audit.audit_type !== 'submit_appeal' && audit.msg_info"
                                            >
                                  ：{{ audit.msg_info }}
                              </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="peopleAppeal.name">
                      <template  v-if="member_type==='system' || member_type==='super'|| member_type==='sysFive'|| member_type==='supFive'">
                        <div class="title">
                          <v-icon class="logo" name="tags" scale="1.6"></v-icon>
                          <p class="titleInfo">审批标记</p>
                        </div>
                        <div style="margin-bottom: 10px">
                          <el-tag
                            :key="tag"
                            v-for="tag in dynamicTags"
                            closable
                            class="tag_tag"
                            style="margin:  5px"
                            effect="dark"
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{tag}}
                          </el-tag>
                          <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model.trim="inputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm"
                          >
                          </el-input>
                          <el-button v-else class="button-new-tag" size="small" @click="showInput">添加标记</el-button>
                        </div>
  
  
                      </template>
                    <div class="title" style="justify-content: space-between;">
                      <div style="display: flex">
                        <v-icon class="logo" name="user" scale="1.6"></v-icon>
                        <p class="titleInfo">个人信息</p>
                      </div>
                    </div>
                      <div class="perInfo">
                        <el-row class="score-row">
                          <el-col :span="8" class="score-col" style="padding: 10px">
                            <img :src="peopleAppeal.profile_picture" alt=""style="width: 130px;height: 150px"   @error="imgError('photo')">
                          </el-col>
                          <el-col :span="8" class="score-col" style="padding: 10px">
                            <img :src="peopleAppeal.id_card_photo_front" alt="" style="width: 270px;height: 150px"  @error="imgError('front')">
                          </el-col>
                          <el-col :span="8" class="score-col" style="padding: 10px">
                            <img :src="peopleAppeal.id_card_photo_verso" alt="" style="width: 270px;height: 150px"  @error="imgError('verson')">
                          </el-col>
                        </el-row>
                        <el-row class="score-row">
                          <el-col :span="12" class="score-col">
                            <p>姓名(中文)：{{ peopleAppeal.name }}</p>
                          </el-col>
                          <el-col :span="12" class="score-col">
                            <p>查询验证码：{{ peopleAppeal.the_query_code }}</p>
                          </el-col>
                        </el-row>
                        <el-row class="score-row">
                          <el-col :span="12" class="score-col">
                            <p>手机号：{{ peopleAppeal.mobile_phone }}</p>
                          </el-col>
                          <el-col :span="12" class="score-col">
                            <p>证件号：{{ peopleAppeal.id_number }}</p>
                          </el-col>
                        </el-row>
                        <el-row class="score-row">
                          <el-col :span="12" class="score-col">
                            <p>提交时间：{{ peopleAppeal.create_time | time }}</p>
                          </el-col>
                          <el-col :span="12" class="score-col">
                            <p>审核状态：{{ peopleAppeal.status | auditStatus }}</p>
                          </el-col>
                        </el-row>
                        <el-row class="score-row">
                          <el-col :span="24" class="score-col">
                            <p style="text-align:left">理由：{{ peopleAppeal.remark}}</p>
                          </el-col>
                        </el-row>
                      </div>
                  </template>
                    <template v-if="peopleAppealDocument.length>0">
                    <div class="title">
                      <v-icon
                        class="logo"
                        name="regular/address-book"
                        scale="1.6"
                      ></v-icon>
                      <p class="titleInfo">证明材料信息</p>
                    </div>
                    <div
                      class="recordInfo"
                    >
                      <el-row class="score-row">
                          <el-col :span="24" class="score-col">
                            <p>
                              <span v-for="(item, index) in peopleAppealDocument"
                                :key="index">
                                  <span v-if="item.document_address" style="color: #4cd964" ><a target="_blank" :href="item.document_address">{{item.document_title}}</a> </span> <br/>
                                </span>
                            </p>
                          </el-col>
                      </el-row>
                    </div>
                  </template>
                </div>
                <div v-else>
                    <yioks-empty tips="数据不存在，请返回上一步重新查询。"></yioks-empty>
                </div>
              </vue-scroll>
          </div>
        <template v-if="verifyFlag">
          <yioks-verify :flag="verifyFlag"
            :verifyBtn="true"
            :holderText="`如审核拒绝，可在此输入理由`"
            @hideVerify="hideVerifyDialog"></yioks-verify>
        </template>
        <template v-if="showEditBlackListDetail">
          <black-list :Info="Info" :title="Title" :showBlackListDialog="showEditBlackListDetail" :notEdit="notEdit" @hideTips="hideTips"></black-list>
        </template>
      </div>
    </template>
  </tea-main>
</template>

<script>
import { getAppealInfo } from "@/api/common/login";
import {peopleAppealAudit,people_appeal_make_tag} from "@/api/system_manager/api";
import {storageData} from "@/assets/js/storage";
import ops from "@/assets/js/vuescrollOption";
import "vue-awesome/icons/user";
import "vue-awesome/icons/regular/address-book";
import 'vue-awesome/icons/tags.js'
import "vue-awesome/icons/regular/clock";
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import placePhoto from "@/assets/images/person.png";
export default {
  name: "appealInfo",
  data() {
    return {
      identify1,
      identify2,
      placePhoto,
      verifyFlag:false,
      notEdit:false,
      Title:'处罚人员详情',
      showEditBlackListDetail:false,
      Info:{},
      id_number: this.$route.query.id_number,
      the_query_code:this.$route.query.the_query_code,
      ops: ops(),
      peopleAppealDocument:[],
      auditData: [],
      peopleAppeal:{},
      member_type:'',
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      loading: true
    };
  },
  created() {
    const member_type=storageData.getUserInfo().member_type;
    this.member_type=member_type;
    this.request();
  },
  methods: {
    verify() {
      this.verifyFlag = true;
    },
    hideVerifyDialog(bool, params, msg) {
      if (bool) {
        peopleAppealAudit({
          appeal_id:this.peopleAppeal.appeal_id,
          status:params,
          msg_info:msg
        }).then(res=>{
          if (Number(res.data.status)===0) {
            this.$message.success('申诉信息审核成功');
            this.request();
            this.verifyFlag = false;
           
          }else{
            this.$message.error(res.data.msg)
            this.verifyFlag = false;
          }
        }).catch(err=>{
          console.log(err);
          this.verifyFlag = false;
        })
      }else{
        this.verifyFlag = false;
      }
    },
    request(flag) {
      this.loading = true;
      getAppealInfo({
          id_number: this.id_number,
          the_query_code: this.the_query_code
      })
        .then(res => {
          if (Number(res.data.status) === 0) {
            const { peopleAppeal, peopleAppealDocument,auditData} = res.data.result;
            this.peopleAppeal=peopleAppeal;
            this.peopleAppealDocument=peopleAppealDocument;
            this.auditData=auditData;
            if (peopleAppeal.record_tags){
              this.dynamicTags=JSON.parse(peopleAppeal.record_tags)
            } else{
              this.dynamicTags=[]
            }
            this.loading = false;
          }else{
              this.loading = false;
              this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      people_appeal_make_tag({
        appeal_id:this.peopleAppeal.appeal_id,
        record_tags:JSON.stringify(this.dynamicTags)
      }).then(res=>{
        if (Number(res.data.status)===0){
        
        }else{
          this.$message.error(res.data.msg)
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        people_appeal_make_tag({
          appeal_id:this.peopleAppeal.appeal_id,
          record_tags:JSON.stringify(this.dynamicTags)
        }).then(res=>{
          if (Number(res.data.status)===0){
          
          }else{
            this.$message.error(res.data.msg)
          }
        }).catch(err=>{
          console.log(err)
        })
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    goBack() {
      this.$router.go(-1);
    },
    lookOver() {
//      this.Info.black_id=this.peopleAppeal.black_id;
//      this.notEdit=true;
//      this.showEditBlackListDetail=true;
      this.$router.push({
        path: 'punishResultInfo',
        query: {black_id: this.peopleAppeal.black_id}
      });
    },
    hideTips(bool,flag){
      this.showEditBlackListDetail=bool;
      if (flag){
        this.$message.success('编辑处罚人员成功！')
        this.request()
      }
    },
    imgListErr(idx) {
      this.$set(this.list[idx], "moment_picture", this.imgSrc);
    },
      imgError(type){
        if (type === 'photo'){
            this.$set(this.peopleAppeal,'profile_picture', this.placePhoto)
        }else  if (type === 'front'){
            this.$set(this.peopleAppeal,'id_card_photo_front', this.identify1)
        }else if (type === 'verson'){
            this.$set(this.peopleAppeal,'id_card_photo_verso',this.identify2)
        }
      }
  },
  filters: {
    auditStatus(status) {
      switch (status) {
        case "audit":
          status = "待审核";
          break;
        case "pass":
          status = "成立";
          break;
          case "refused":
          status = "驳回";
          break;
        default:
          status = "";
          break;
      }
      return status;
    },
  },
  components: {
    "tea-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
      "yioks-status": () => import("@/components/Tips/Status"),
    "yioks-verify": () => import("@/components/Tips/verify-appeal"),
    "black-list" : () => import("@/components/Tips/edit_and_look_blackList"),
  }
};
</script>

<style scoped lang="stylus">
@import "~@/assets/css/variable";
@import "~@/assets/css/mixin";
@import "~@/assets/css/nav_filter";
.recordNav, .recordMain {
    flex: 1 1 auto;
    height: 100%;
}
.recordNav {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 0 12px 0 0;
     font-size: $font_size_big;
    .audit{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 15px;
        font-size: 16px;
        background-color: $color_suc;
        cursor: pointer;
    }
 }

.recordMain {
    width: 100%;
    padding: 25px 0 25px 0;
    background-color: $block_bg_color_base;
    .Info{
        padding 0 0 0 40px
        height 550px
        .mainInfo{
            padding-right 40px
            .perInfo,.recordInfo{
                position: relative;
                margin-bottom: 40px;
                border: 1px solid $color_white;
                .score-row {
                    border-bottom: 1px solid $color_white;
                    .score-table {
                        .row {
                            border-bottom: 1px solid $color_white;
                            display:flex;
                            &:last-child {
                                border-bottom: none;
                            }
                            .score-col {
                                text-align: center;
                                border-left: 1px solid $color_white;
                                flex:auto;
                                &:first-child {
                                    border-left: none;
                                }
                                p {
                                    margin: 10px;
                                    font-size: $font_size_medium;
                                    word-break: break-all;
                                    &.score-note {
                                        text-align: left;
                                    }
                                }
                            }
                        }
                    }
                    &:last-child {
                        border-bottom: none;
                    }
                    .score-col {
                        text-align: center;
                        border-left: 1px solid $color_white;
                        &:first-child {
                            border-left: none;
                        }
                        p {
                            margin: 10px;
                            font-size: $font_size_medium;
                            word-break: break-all;
                            &.score-note {
                                text-align: left;
                            }
                        }
                    }
                }
                .dashed-line {
                    width: 100%;
                    position: absolute;
                    bottom: -22px;
                    left: 0;
                    border: 1px dashed $color_white;
                }
                &:last-child{
                    margin-bottom 0
                }
            }
            .title{
                display flex
                margin-bottom 10px
                .titleInfo{
                    margin-left 10px
                    font-size 18px
                    line-height 1.6
                }
              .zuxie-btn{
                background none;
                border 1px solid;
                width: 115px;
                padding: 10px 4px;
                &:hover{
                  background $color_primary;
                }
              }
            }
            .timeline {
                  display block
                  padding-left 3px
                  .timeline-item {
                      position relative
                      padding-bottom 20px
                      .item_tail {
                          position absolute
                          top 36px
                          bottom 6px
                          left 16px
                          // height 100%
                          border-left 2px solid #cccccc
                      }
                      .item_node {
                          position absolute
                          background-color #fff
                          color #333
                          border 1px solid #fff
                          border-radius 50%
                          // left -2px
                          width 36px
                          height @width
                          font-size: 12px;
                          display flex
                          align-items center
                          text-align: center;
                          justify-content center
                      }
                      .item_wrap {
                          position: relative;
                          padding-left: 50px;
                          top: -3px;
                          .timestamp {
                              display flex
                              // align-items center
                              line-height 1
                              margin-bottom 5px
                              font-size 15px
                              .audit_people {
                                  flex 1
                                  text-align right
                                  margin-left 10px
                              }
                          }
                          .item_cont {
                              display block
                              background-color #fff
                              color #333
                              padding 10px
                              border-radius: 4px;
                              border: 1px solid #cccccc;
                              overflow: hidden;
                              font-size:15px;
                              box-shadow 0 2px 12px 0 rgba(255,255,255,.1)
                          }
                      }
                  }
              }
            .el-tag + .el-tag {
                margin-left: 10px;
            }
            .button-new-tag {
                margin-left: 10px;
                height: 32px;
                line-height: 30px;
                padding-top: 0;
                padding-bottom: 0;
            }
            .input-new-tag {
                width: 90px;
                margin-left: 10px;
                vertical-align: bottom;
            }
        }


    }
}
</style>
<style lang="stylus">
    .tag_tag{
        height  auto
        white-space normal
    }
</style>
